<div class="wrap">
  <ng-container *ngIf="!confirm">
    <h2>{{title}}</h2>

    <ngx-simplebar>
      <form *ngIf="!isLoading" id="addClub" [formGroup]="addClubForm" (ngSubmit)="onSubmit()">

        <mat-form-field appearance="outline">
          <mat-label>Nom du club</mat-label>
          <input matInput type="text" formControlName="clubName">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>N° du club</mat-label>
          <input matInput type="text" formControlName="clubCode">
        </mat-form-field>

        <div class="address_club">
          <mat-form-field appearance="outline" class="address">
            <mat-label>Adresse</mat-label>
            <input matInput type="text" formControlName="address">
          </mat-form-field>

          <mat-form-field appearance="outline" class="number">
            <mat-label>N° </mat-label>
            <input matInput type="text" formControlName="addressNumber">
          </mat-form-field>

          <mat-form-field appearance="outline" class="box">
            <mat-label>Boite</mat-label>
            <input matInput type="text" formControlName="box">
          </mat-form-field>
        </div>

        <div class="postalCode_city">
          <mat-form-field appearance="outline" class="postalCode">
            <mat-label>CP</mat-label>
            <input matInput type="text" formControlName="postalCode">
          </mat-form-field>

          <mat-form-field appearance="outline" class="city">
            <mat-label>Ville</mat-label>
            <input matInput type="text" formControlName="city">
          </mat-form-field>
        </div>
        <mat-form-field appearance="outline">
          <mat-label>Tél.</mat-label>
          <input matInput type="phone" formControlName="phoneNumber">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Personne de contact</mat-label>
          <input matInput type="text" formControlName="contactPerson">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Mail</mat-label>
          <input matInput type="mail" formControlName="mail">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Téléphone pour confirmation sms</mat-label>
          <input matInput type="phone" formControlName="smsPhoneNumber">
        </mat-form-field>

        <mat-form-field appearance="outline" *ngIf="userConnected.role!=='club'">
          <mat-label>Nombre d'offres prioritaires possibles</mat-label>
          <input matInput min="0" type="number" formControlName="limitPriorities">
        </mat-form-field>

        <section *ngIf="userConnected.role !== 'club'">
          <h3>Fédération(s)</h3>

          <mat-list formArrayName="federation" class="federationList">
            <mat-list-item class="numberListItem" *ngFor="let control of getArray('federation').controls; index as i"
              [formGroupName]="i">
              <div matLine>
                <app-autocomplete [control]="control" [list]="federations" label="Fédération"
                  errorMsg="Veuillez sélectionner une fédération">
                </app-autocomplete>
              </div>
              <button *ngIf="i !== 0" type="button" matTooltip="Retirer la fédération" mat-icon-button color="primary"
                (click)="removeFederation(i)">
                <fa-icon [icon]="getFaIcon('faTrashAlt')" appChangeColorTheme attribute="color"></fa-icon>
              </button>
            </mat-list-item>


            <mat-list-item *ngIf="getArray('federation').controls.length < 8">
              <button type="button" mat-icon-button color="primary" matTooltip="Ajouter une fédération"
                (click)="addFederation()">
                <fa-icon [icon]="getFaIcon('faPlus')" appChangeColorTheme attribute="color"></fa-icon>
              </button>
            </mat-list-item>
          </mat-list>
        </section>



      </form>

      <mat-spinner *ngIf="isLoading" [diameter]="75"></mat-spinner>
    </ngx-simplebar>

    <div class="btn_action" *ngIf="!isLoading">
      <button class="back" type="button" (click)="dialogRef.close()">Annuler</button>
      <button form="addClub" [ngClass]="{not_confirm: addClubForm.invalid, confirm: addClubForm.valid}" type="submit"
        [disabled]="addClubForm.invalid" appChangeColorTheme>{{btnConfirm}}</button>
    </div>
  </ng-container>

  <div class="validation_align"> <app-validation-animation [text]="text" *ngIf="confirm"></app-validation-animation>
  </div>

</div>